import { render } from "./studyPlan.vue?vue&type=template&id=15d3249a&scoped=true"
import script from "./studyPlan.vue?vue&type=script&lang=js"
export * from "./studyPlan.vue?vue&type=script&lang=js"

import "./studyPlan.vue?vue&type=style&index=0&id=15d3249a&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d3249a"]])

export default __exports__